import { useQuery } from "@tanstack/react-query";
import { useAuthenticatedFetch } from "@/hooks/use-authenticated-fetch";
import { OFFLINE_DURABLE_GC_TIME, userKeys } from "@/lib/query-keys";
import type { UserProfile } from "@/types/api";

export function useCurrentUser() {
  const fetchWithAuth = useAuthenticatedFetch();

  return useQuery({
    queryKey: userKeys.me(),
    queryFn: () => fetchWithAuth<UserProfile>("/users/1.0/users/me/"),
    staleTime: 5 * 60 * 1000,
    gcTime: OFFLINE_DURABLE_GC_TIME,
  });
}
